var map = {
	"./brightness.svg": [
		"c196",
		"icon-brightness-svg"
	],
	"./camera.svg": [
		"24e5",
		"icon-camera-svg"
	],
	"./close.svg": [
		"8b1b",
		"icon-close-svg"
	],
	"./contrast.svg": [
		"acd7",
		"icon-contrast-svg"
	],
	"./download.svg": [
		"f28e",
		"icon-download-svg"
	],
	"./gallery.svg": [
		"6ec0",
		"icon-gallery-svg"
	],
	"./info.svg": [
		"76ed",
		"icon-info-svg"
	],
	"./logo-facebook.svg": [
		"ad96",
		"icon-logo-facebook-svg"
	],
	"./logo-freunde-der-nationalgalerie.svg": [
		"850d",
		"icon-logo-freunde-der-nationalgalerie-svg"
	],
	"./logo-meta.svg": [
		"bccf",
		"icon-logo-meta-svg"
	],
	"./logo-nationalgalerie.svg": [
		"db9f"
	],
	"./saturation.svg": [
		"6bc3",
		"icon-saturation-svg"
	],
	"./temperature.svg": [
		"816a",
		"icon-temperature-svg"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "153d";
module.exports = webpackAsyncContext;